<template>
  <div>
    <slot name="info"></slot>
    <dialog-edit2 :value="value" @input="$emit('input')">
      <template v-slot:title>
        <small v-if="id"> ({{ id }})</small>
        {{ id ? m.title + ` №${data.code_doc}` : "Новый документ '" + m.title + "'" }}
        [{{ statusCurrent.text || "" }}]
        <br />
        {{ config.name }}
      </template>
      <a-loader v-if="loading" />
      <v-row v-else>
        <v-col
          cols="12"
          sm="12"
          class="pb-0"
          v-if="
            !id &&
            !document.id &&
            model.find(m => {
              return m.name == 'parent_id';
            })
          "
        >
          <v-btn @click="showSelectDialog = true"> Выбрать документ </v-btn>
        </v-col>
        <v-col v-if="modelForm" v-for="(el, i) in modelForm" :key="i" cols="12" :sm="el.size" class="py-0">
          <a-form-view
            v-if="el.name == 'balance'"
            :value="balance"
            :model="[
              { name: 'debit', title: 'Всего к оплате по документу', type: 'number' },
              { name: 'credit', title: 'Всего выплачено по документу', type: 'number' },
              { name: 'saldo', title: 'Не выплачено по документу', value: -balance.credit + balance.debit, type: 'number' },
            ]"
            @click="getBalance()"
            :config="{ dense: true }"
          />
          <div v-else v-for="name in el.name.split('+')" :key="name">
            <a-form-model
              :ref="'field_' + name"
              v-model="data"
              :model="getFormModel([name])"
              :errors="errors"
              :config="{ dense: true, readonly }"
              @validate="validate($event)"
            />
          </div>
        </v-col>
      </v-row>

      <template v-slot:actions>
        <a-btn-status v-if="!loading && isStatus" :items="statusItems" @click="changeStatus($event)" :disabled="!canStatus" />
        <v-btn v-if="!loading && data.status == 2" :href="getPreview()" target="_blank" class="mx-1" dark color="info" title="Печать">
          <v-icon dark>fas fa-print </v-icon>
        </v-btn>
        <a-btn-acc-record v-if="data.status" :id="id" :name="m.accDocName" />
        <v-spacer></v-spacer>
        <a-btn-import-data v-if="data.import_data" :value="data.import_data" :model="{ name: 'import_data', title: 'Данные импорта' }" />
        <a-btn-delete v-if="!loading && id && isDelete" @click="removeDialogShow = true" />
        <a-btn-save v-if="!loading && isEdit" @click="submit()" :color="isChanged ? 'green' : 'primary'" />

        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
    <select-dialog v-model="showSelectDialog" v-if="showSelectDialog" :config="config" @select="onSelectDocument($event)" />
    <remove-dialog v-model="removeDialogShow" @remove="remove(api, id)" />
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, getAccess, genModel } from "@/components/mixings";
import libsCashAccess from "./../../libsCashAccess";

export default {
  components: {
    selectDialog: () => import("./selectDialog"),
  },
  mixins: [getForm, submitForm, removeEl, getAccess, libsCashAccess, genModel],
  props: {
    value: Boolean,
    id: Number,
    initData: Object,
    document: {
      type: Object,
      default: () => {
        return {};
      },
    },
    config: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      m: this.config.m,
      api: this.config.m.api,
      apiStatus: this.config.m.api,
      removeDialogShow: false,
      showSelectDialog: false,
      loaded: false,
      baseId: null,
      modelForm: null,
      debit: null,
      credit: null,
      isPrint: false,
    };
  },
  computed: {
    balance() {
      return { debit: this.debit, credit: this.credit };
    },

    model: {
      get() {
        return this.calcModel();
      },
    },

    editObject() {
      return false;
    },
    canStatus() {
      return !this.loading && !this.isChanged && this.data.id;
    },
    statusItems() {
      if (!this.data.status) return [];
      let items = [];
      let res = [];
      const statuses = this.m.statuses;
      const statusCur = statuses.find(el => el.value == this.data.status);
      if (statusCur && statusCur.next && statuses) {
        let arr = statusCur.next;
        res = statuses.filter(s => {
          return arr.includes(s.value);
        });
      }
      items = JSON.parse(JSON.stringify(res));
      return items;
    },
    statusCurrent() {
      let statusCur = this.m.statuses.find(el => el.value == this.data.status);
      if (!statusCur) {
        statusCur = {};
      }
      return JSON.parse(JSON.stringify(statusCur));
    },
  },
  created() {
    this.loaded = false;
    this.updateData(this.id);
    if (this.id) {
    } else {
      this.onInitData();
      this.data.parent_name = this.config?.document?.accDocName || this.initData?.parent_name || null;
      this.data.operation_type = this.config.id;
      if (this.document?.id) {
        this.onSelectDocument(this.document);
      } else {
        if (
          this.model.find(m => {
            return m.name == "parent_id";
          })
        )
          this.showSelectDialog = true;
      }
    }
  },
  watch: {
    value1() {
      if (this.value) {
        this.updateData(this.id);
        if (!this.id) {
          this.type = 1;
          //  this.data.status = 0;
        }
      }
    },
  },
  methods: {
    getPreview() {
      return this.$root.config.baseUrl + this.api + `/${this.id}/print?token=` + localStorage.getItem("user-token");
    },
    onInitData() {
      console.log("initData", this.initData);
      if (!this.initData) return;
      for (const key in this.initData) {
        this.data[key] = this.initData[key];
      }
    },
    onSelectDocument(e) {
      console.log("onSelectDocument", e);
      this.loading = true;
      if (this.config.document?.fieldsConfig) {
        const config = this.config.document?.fieldsConfig;
        for (const key in config) {
          if (this.data.hasOwnProperty(key) || 1 == 1) {
            if (config[key].type === "field") {
              //this.data[key] = e[config[key].value];
              this.setData(key, e[config[key].value]);
            } else if (config[key].type === "value") {
              this.setData(key, config[key].value);
            } else {
              console.log("не известный тип сопоставления данных " + config[key].type);
            }
          } else {
            console.log("не найдено поле для сопоставления данных " + key);
          }
        }
      }
      this.data.parent_id = e.id;

      this.getBalance();
      this.loading = false;
    },
    afterRemove(data) {
      this.removeDialogShow = false;
      this.$emit("input");
    },
    afterSave(data, status) {
      this.isChanged = false;
      return;
      if (status) this.$emit("input");
    },
    afterFetchData(r) {
      if (this.id) {
        this.getBalance();
      }
      this.loaded = true;
    },
    async getBalance() {
      let doc_id = this.data?.[this.config.document?.field];
      if (!doc_id) return;
      doc_id = String(doc_id);
      let debit = 0;
      let credit = 0;
      const acc = this.config.credit;
      let resp = await this.$axios.get("/accounting/records", {
        params: {
          filters: { debit_account: acc, debit_subconto_value_2: doc_id },
        },
      });
      if (resp.data.status == "ok") {
        resp.data.data.forEach(el => {
          debit += el.value;
        });
      }
      resp = await this.$axios.get("/accounting/records", {
        params: {
          filters: { credit_account: acc, credit_subconto_value_2: doc_id },
        },
      });
      if (resp.data.status == "ok") {
        resp.data.data.forEach(el => {
          credit += el.value;
        });
      }
      //  return { credit: credit, debit: debit };
      this.credit = credit;
      this.debit = debit;
    },
    calcModel(t) {
      const config = this.config;
      let model = JSON.parse(JSON.stringify(this.m.form));
      model = this.replaceFields(model, config?.fieldsReplace);

      this.isPrint = config?.isPrint || false;
      const fields = config.fields ? config.fields.split(",") : [];
      let fieldsRO = config.fieldsRO ? config.fieldsRO.split(",") : [];
      if (this.data.status == 2) fieldsRO = fields;
      const fieldsForm = config.fieldsForm ? config.fieldsForm.split(",") : [];
      model = model.filter(el => {
        return fields.includes(el.name);
      });
      model.forEach(el => {
        if (fieldsRO.includes(el.name)) {
          el.readonly = true;
        }
      });
      let modelForm = [];
      fieldsForm.forEach(field => {
        let f = field.split("#");
        modelForm.push({ name: f[0], size: f[1] || 12 });
      });
      this.modelForm = modelForm;
      return model;
    },
    async changeStatus(status) {
      if (this.config?.balanceCheck) {
        if (status.value == 2) {
          await this.getBalance();
          if (this.debit - this.credit - this.data.value < 0) {
            this.$root.$emit("show-info", {
              type: "error",
              text: "ОШИБКА. Баланс по документу отрицательный",
            });
            return false;
          }
        }
      }
      let id = this.data.id;
      if (!id) {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Что-то пошло не так....",
        });
        return;
      }
      this.loading = true;
      let data = { id, status: status.value };
      let response = await this.$axios.post(this.apiStatus, data);
      this.loading = false;
      status = response.data.status == "ok";
      if (response.data.data) {
        Object.assign(this.data, response.data.data);
        this.$root.$emit("show-info", {
          text: "Статус изменен",
        });
      }
      this.getBalance();
    },
  },
};
</script>
